// Published marketing price (Website Epic WD1). The ONLY place the marketing
// site states the coach subscription price. The app itself never reads this;
// it renders the live Stripe price from /api/config. The Playwright guard
// e2e/website-price-guard.spec.js fails if production /api/config and this
// constant disagree, so a Stripe price change forces a copy update here.
export const PUBLISHED_PRICE_CENTS = 100;
export const TRIAL_DAYS = 14;
// What one coach subscription includes (PO 2026-09-30). Every coach pays it
// after the trial, whatever the program type; "unlimited" only where the code
// has no cap (texts and album uploads have safety caps, so they are "included").
export const INCLUDED = 'unlimited basketball programs, seasons, families, players and games';

export const priceDollars = (cents = PUBLISHED_PRICE_CENTS) => (cents / 100).toFixed(2); // "1.00"
export const priceAmount = (cents = PUBLISHED_PRICE_CENTS) =>
  cents % 100 === 0 ? `$${cents / 100}` : `$${(cents / 100).toFixed(2)}`;               // "$1"
export const priceLabel = (cents = PUBLISHED_PRICE_CENTS) => `${priceAmount(cents)}/month`; // "$1/month"

// schema.org SoftwareApplication with the same offer, injected into <head>
// on the landing page (react-snap captures Helmet tags into the prerender).
export const softwareApplicationJsonLd = () => ({
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'HoopHero',
  url: 'https://www.hoophero.net/',
  logo: 'https://www.hoophero.net/logo-square.png',
  image: 'https://www.hoophero.net/logo-wide.png',
  description:
    'Youth basketball program management for coaches and parents: paid, free, and YMCA programs. Rosters, schedules, RSVP and attendance with automatic chasers, live scoreboard links, team chat, photo and video albums, carpool and volunteer sign-ups, payment tracking, two-way messaging, automatic reminders, and several programs on one login.',
  applicationCategory: 'BusinessApplication',
  applicationSubCategory: 'SportsManagement',
  operatingSystem: 'Web',
  offers: {
    '@type': 'Offer',
    price: priceDollars(),
    priceCurrency: 'USD',
    priceSpecification: {
      '@type': 'UnitPriceSpecification',
      price: priceDollars(),
      priceCurrency: 'USD',
      unitText: 'MONTH',
    },
    availability: 'https://schema.org/InStock',
  },
  publisher: {
    '@type': 'Organization',
    name: 'Clarity Growth Pro LLC',
    url: 'https://claritygrowthpro.com',
    logo: 'https://www.hoophero.net/logo-square.png',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '24073 Flora Parke Blvd.',
      addressLocality: 'Fernandina Beach',
      addressRegion: 'FL',
      postalCode: '32034',
      addressCountry: 'US',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+1-904-921-2519',
      contactType: 'customer service',
      email: 'ruben@claritygrowthpro.com',
      areaServed: 'US',
      availableLanguage: 'English',
    },
  },
});
